import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { EncryptionService } from '../../services/encryption.service';
import { CRMService } from '../../services/crm.service';
import { OrderService } from '../../services/order.service';
import { SearchCustomer, SearchQuoteOrder, SearchQuoteOrderLine } from '../../models/models';

@Component({
    selector: 'order-tracking',
    templateUrl: './order-tracking.component.html',
    styleUrls: [
        './order-tracking.component.css'
    ],
    standalone: false
})
export class OrderTracking implements OnInit {
    public quoteOrderID: number = 0;
    public orderNumber: string = "";
    public gaugeValue: number = 0;
    public orderStatus: string = '';
    public plannedLabel: string = '1';
    public inTransitLabel: string = '2';
    public deliveredLabel: string = '3';
    public quoteOrder: SearchQuoteOrder = {} as SearchQuoteOrder;
    public quoteOrderLines: SearchQuoteOrderLine[] = [];
    public shipper: SearchCustomer = {} as SearchCustomer;
    public consignee: SearchCustomer = {} as SearchCustomer;

    constructor(private crmService: CRMService, private orderService: OrderService, private encryptionService: EncryptionService,
        private route: ActivatedRoute, private titleService: Title, private router: Router) {
        this.titleService.setTitle('Order Tracking');
    }

    ngOnInit() {
        this.getUnencryptedQuoteOrderID();
    }

    private getUnencryptedQuoteOrderID() {
        this.route.params.subscribe(params => {
            this.encryptionService.getSplitUnencryptedValues(encodeURIComponent(params.encryptedQuoteOrderID)).subscribe(result => {
                this.quoteOrderID = parseInt(result[0]);
                this.getTrackingData();
            });
        });
    }

    private getTrackingData() {
        this.getQuoteOrder();
        this.getQuoteOrderLines();
    }

    private getQuoteOrder() {
        this.orderService.getSearchQuoteOrderByID(this.quoteOrderID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.quoteOrder = result.resultCollection[0];
                this.orderNumber = this.quoteOrder.orderNumber;
                this.getCustomerByID(this.quoteOrder.shipperID, "shipper");
                this.getCustomerByID(this.quoteOrder.consigneeID, "consignee");
            }
        });
    }

    private getQuoteOrderLines() {
        this.orderService.getSearchQuoteOrderLinesByQuoteOrderID(this.quoteOrderID).subscribe(result => {
            this.quoteOrderLines = result.resultCollection;
            this.setOrderStatus();
        });
    }

    private getCustomerByID(id: number, customerType: string) {
        this.crmService.getSearchCustomerByID(id).subscribe(result => {
            if (result.resultCollection.length > 0) {
                if (customerType == "shipper") {
                    this.shipper = result.resultCollection[0];
                }
                else if (customerType == "consignee") {
                    this.consignee = result.resultCollection[0];
                }
            }
        });
    }

    private setOrderStatus() {
        this.orderStatus = this.quoteOrderLines[0].customerOrderStatus;
        if (this.orderStatus == "Delivered") {
            this.gaugeValue = 100;
            this.plannedLabel = "&#10003;";
            this.inTransitLabel = "&#10003;";
            this.deliveredLabel = "&#10003;";
        }
        else if (this.orderStatus == "In Transit") {
            this.gaugeValue = 50;
            this.plannedLabel = "&#10003;";
        }
        else {
            this.gaugeValue = 10;
        }
    }
}
